// removed by extract-text-webpack-plugin
module.exports = {"container":"_1L6zWFsVSWiuj9JB4Aoarq","icon":"_1BdPYhIa3s6BSgP9_Y8vfA","title":"_37OAa-nsaLIc2-tvD0jySp","button":"_1C9YT3ZUQpwmkUUXCACn8A"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/UpdateSigners/styles.css
// module id = 2856
// module chunks = 0